<template>
  <div class="modal-container clearfix">
    <vxe-form
        style="margin-top: 20px"
        ref="xForm"
        class="my-form2"
        title-align="right"
        title-width="110"
        :data="formData"
        :rules="formRules">
      <vxe-form-item title="购买次数" field="count" span="24">
        <template>
          <div class="flex">
            <vxe-input v-model="formData.count" style="width: 200px" type="integer" min="1"></vxe-input>
            次
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="截止有效期" field="endTime" span="24">
        <template>
          <vxe-input type="datetime" v-model="formData.endTime" style="width: 200px"></vxe-input>
        </template>
      </vxe-form-item>
    </vxe-form>
    <div class="modal-footer add-btn-box">
      <Button @click="close" style="border-radius: 5px;">取 消</Button>
      <Button type="primary" style="border-radius: 5px;" @click="commit">确 定</Button>
    </div>
  </div>
</template>
<script>

import $api from "@/apiProvider";
import {hideLoading, showLoading} from "@/utils/util";
import moment from "moment";

export default {
  props: ['userId'],
  data() {
    return {
      formData: {
        count: null,
        endTime: null,
      },
      formRules: {
        count: [{required: true, message: "请输入购买次数"}],
        endTime: [{required: true, message: "请选择有效期"}],
      }
    }
  },
  mounted() {
    this.formData.endTime = this.$utils.toDateString(moment().startOf('day') + 31536000000, "yyyy-MM-dd");
  },
  methods: {
    async validEvent() {
      let errMap = await this.$refs.xForm.validate().catch((errMap) => errMap);
      return errMap ? false : true;
    },
    async commit() {
      let sts = await this.validEvent();
      if (!sts) {
        return;
      }

      this.createUserTrackMonthManage();
    },
    async createUserTrackMonthManage() {
      if (this.$utils.timestamp(this.formData.endTime) <= moment().startOf('day')) {
        this.$XModal.alert({
          message: '截止时间错误',
          status: "error",
        });
        return
      }
      showLoading();
      let res = await $api.seachart.request("createUserTrackMonthManage", {
        userId: this.userId,
        count: this.formData.count,
        endTime: this.$utils.timestamp(this.formData.endTime),
        recordType: 1
      });
      hideLoading();
      if (res.code === 1) {
        this.$Message.success("新增成功");
        this.$emit('afterSave');
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    close() {
      this.$emit('afterSave');
    }
  }
}
</script>
<style scoped>
.modal-footer {
  padding: 10px 0;
  display: flex;
  justify-content: flex-end;
  width: 96%;
  position: absolute;
  bottom: 0;
}

.flex {
  display: flex;
  align-items: center;
}
</style>